/**
 * Vehicle Cart Properties
 * Injects the customer's saved vehicle into the product form as a line item property
 * This ensures fulfillment team can see which vehicle the rack is for
 */

(function() {
  'use strict';

  const STORAGE_KEY = 'leitner_saved_vehicles';

  /**
   * Get the active (first) saved vehicle from localStorage
   * @returns {Object|null} Vehicle object with year, make, model properties
   */
  function getActiveVehicle() {
    try {
      const saved = localStorage.getItem(STORAGE_KEY);
      if (!saved) return null;
      const vehicles = JSON.parse(saved);
      if (!Array.isArray(vehicles) || vehicles.length === 0) return null;
      return vehicles[0]; // First vehicle is the active one
    } catch (e) {
      console.error('Error reading saved vehicles:', e);
      return null;
    }
  }

  /**
   * Format vehicle for display
   * @param {Object} vehicle - Vehicle object
   * @returns {string} Formatted string like "2024 Toyota Tacoma"
   */
  function formatVehicle(vehicle) {
    if (!vehicle) return '';
    const parts = [vehicle.year, vehicle.make, vehicle.model].filter(Boolean);
    return parts.join(' ');
  }

  /**
   * Inject vehicle into all product form hidden inputs on the page
   */
  function injectVehicleProperty() {
    const vehicle = getActiveVehicle();
    const vehicleString = formatVehicle(vehicle);

    // Find all vehicle property inputs (supports multiple product forms on page)
    const inputs = document.querySelectorAll('[data-vehicle-property]');

    inputs.forEach(input => {
      input.value = vehicleString;
    });

    // Log for debugging (remove in production if needed)
    if (vehicleString) {
      console.log('Vehicle property injected:', vehicleString);
    }
  }

  /**
   * Initialize on DOM ready
   */
  function init() {
    injectVehicleProperty();

    // Listen for vehicle changes (from vehicle-selector.js)
    document.addEventListener('vehicle:saved', injectVehicleProperty);
    document.addEventListener('vehicle:changed', injectVehicleProperty);
    document.addEventListener('vehicle:removed', injectVehicleProperty);

    // Also re-inject when Shopify sections are rendered (for AJAX updates)
    document.addEventListener('shopify:section:load', injectVehicleProperty);

    // Re-inject when variant picker updates the form (in case form is replaced)
    document.addEventListener('variant:change', injectVehicleProperty);
  }

  // Initialize when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Expose for external use if needed
  window.LeitnerVehicleCartProperties = {
    getActiveVehicle,
    formatVehicle,
    injectVehicleProperty
  };
})();
